
<template>
	<div class="page-container">
		<HeaderLayout :pagecode="'join'"></HeaderLayout>
		<div class="content">
		    <div class="main-content">
				<h2 class="text-name">{{title}}</h2>
				<p class="text-name-1">{{subTitle}}</p>
		
					<div class="from-box">
						<form  id="updateForm" action="memberProc/findPassword" novalidate @submit="formSubmit">
						<input type='hidden' name="cmd" id="cmd" :value="cmd" />	
							<div class='form-group'  v-if="cmd=='pw'">   
								<md-field>
								  <label>아이디</label>
								  <md-input :required="true" name="uid" id="uid"></md-input>
								</md-field>
								<div class="md-error-box">아이디를 입력하세요</div>
							</div>
							<div class='form-group' v-else>   
								<md-field>
								  <label>이름</label>
								  <md-input :required="true" name="name" id="name"></md-input>
								</md-field>
								<div class="md-error-box">이름을 입력하세요</div>
							</div>
							
							<div class='form-group'>   
								<md-field>
								  <label>휴대폰 번호</label>
								  <md-input :required="true"  autocomplete="off"  type="text" name="pcs" id="pcs"></md-input>
								</md-field>
								<div class="md-error-box">휴대폰번호를 입력하세요</div>
							</div>
							
							<div class='form-group' v-if="cmd=='pw'">   
								<md-field>
								  <label>이메일 주소</label>
								  <md-input :required="true"  autocomplete="off"  type="text" name="email" id="email"></md-input>
								</md-field>
								<div class="md-error-box">이메일주소를 입력하세요</div>
							</div>
							<div style='clear:both;'></div>
							<div style="padding-top:30px;">
								<md-button class="md-raised md-primary" style='width:100%;border-radius:30px;margin:0;height:45px;' type="submit">확 인</md-button>
							</div>
						</form>
					</div>
			  </div>
		</div>
		<FooterLayout></FooterLayout>

		<div class="screenLayout" v-if="screenView">
			<div class="content-wrapper">
				<div class="content-box" style='width:500px;border-radius:0;'>
					<h3>알림</h3>
					<div class="description" v-html="msg"></div>
					<div style="padding-top:30px;display:flex;text-align:center;">
						<md-button class="md-raised md-primary" v-if="cancleView" style='width:47%;background:#999;border-radius:30px;margin:0 6% 0 0;height:45px;' @click="closeModal()" type="button">취 소</md-button>
						<md-button class="md-raised md-primary" style='width:47%;border-radius:30px;margin:0 auto;height:45px;' @click="doAction()" type="button">{{buttonMsg}}</md-button>
					</div>
				</div>
			</div>
		</div>
	</div>	
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
  name: 'MemberFindPw',
  components: {
	  HeaderLayout,
	  FooterLayout,
  },
  data () {
	
	return {
  	   title:'', 
	   cmd:'',
	   subTitle:'',
	   screenView:false,
	   cancleView:false,
	   result:'',
	   msg:'',
	   buttonMsg:'확인',
    }
  },
  created: function() {
	  if(this.$route.params.cmd=='id') {
		this.title = '아이디 찾기';
		this.subTitle = '아이디를 안내해 드립니다';
	  } else {
		this.title = '비밀번호 찾기';
		this.subTitle = '비밀번호를 안내해 드립니다';
	  }
	  this.cmd = this.$route.params.cmd;	
	  	
	
  },
  methods: {

	  formSubmit(e) {
		 var $f = $('#updateForm');
		var obj = this;
		this.$form.validate($f,e,function(resp) {
			obj.updateInfo(resp);
			
		});
		
	  },
	  updateInfo(resp) {

		  var result = resp.result;
		  var params = {};
		  this.result = result;
		  switch(result) {
			  case 'succ':
				this.msg = '임시비밀번호를 가입된<br>이메일로 발송하였습니다';
				this.screenView = true;
				this.cancleView = false;
				this.buttonMsg  = '확 인';
				
			 break;
			  case 'notemail':
				params.content = '시스템 이메일 설정이 필요합니다';	
				this.$eventBus.$emit('dialogOpen',params);
			  break;
			  case 'sns':
				params.content = 'SNS로 가입된 계정입니다';	
				this.$eventBus.$emit('dialogOpen',params);
			  break;
			  case 'fail':
				if(this.cmd == 'id') {
					this.msg = '가입된 아이디가 없습니다<br>회원가입 하시겠습니까?';
					this.buttonMsg  = '회원 가입';
				} else {
					this.msg = '입력된 정보와 일치하는 회원이 없습니다<br>아이디를 확인 하시겠습니까?';
					this.buttonMsg  = '아이디 확인';
				}
				this.cancleView = true;
				this.screenView = true;
			  break;
			  default:
				this.msg = '가입하신 아이디를 안내해드리겠습니다<br>가입하신 아이디는 <b>'+result+'</b> 입니다';
				this.screenView = true;
				this.cancleView = false;
			  break;
			  
		  }
		  
	  },
	  doAction() {
		if(this.cmd == 'id') {
			
			switch(this.result) {
				case 'fail':
					this.$router.push({path:'/member/join'});
				break;
				default:
					this.screenView = false;		
				break;
			}
		} else {
			switch(this.result) {
				case 'fail':
					this.$router.push({path:'/member/findPw/id'});

					this.title = '아이디 찾기';
					this.subTitle = '아이디를 안내해 드립니다';
					this.cmd = 'id';	
					$('#pcs').val('');
					$('#name').val('');
					this.screenView = false;	
				break;
				default:
					this.screenView = false;		
				break;
			}
		}
	  },
	  closeModal() {
		this.screenView = false;
	  }

  },
  mounted: function() {
	$('.page-container').css('min-height',$(window).height());
	
  }

}
</script>

<style lang="scss" scoped>
.md-content {margin:0;padding-top:50px;}
.page-container {
	width:100%;min-height:100%;
	background:#fff;
	.content {
		width:100%;
		height:auto;
		padding:150px 0 100px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#fff;
		.main-content {
			width:400px;
			min-height:550px;
			margin:0 auto;
			.text-name {
				font-size:26px;
				font-weight:normal;
				color:#414141;
				line-height:100%;
				margin-bottom:0;
			}
			.text-name-1	{
						margin-top:15px;
						color:#B3B3B3;
						font-size:11px;
						padding-bottom:30px;
						line-height:13pt;
			}
			.text-label			{
						color:#B3B3B3;
						font-size:13px;
						
			}
			.text-input		     {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input			{
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
						
			}
		
			.text-input.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-select		{
						padding:10px 0;
						width:100%;
						input      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #EDEDED;
								width:45%;
						}
						input.md-focused {
							border-bottom:2px solid #3D79FE;
						}
						.text-a      {
								width:10%;
								font-size:18px;
								display:inline-block;
								text-align:center;
						}
						select      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #DEDEDE;
								width:45%;
								font-size:12px;
								
						}
						select.md-focused {
							border-bottom:2px solid #3D79FE;
						}
			}
			.text-select-1  {
						padding:20px 0;
						border-bottom:1px solid #EDEDED;
						width:100%;
						position:relative;
						input  {
						         width:70%;
								 border:none;
								 outline:none;
						}
						.box-adder		{
								 width:90px;
								 padding:5px;
								 border-radius:20px;
								 border:1px solid #DEDEDE;
								 display:inline-block;
								 text-align:center;
								 font-size:12px;
								 position:absolute;
								 right:5px;
								 cursor:pointer;
								
						}
			}
			.text-select-1.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-box-input          {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input          {
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
			}
			.box-check       {
					  margin-bottom:12px;
					  font-size:13px;
					  input      {
					  		  width:15px;
							  height:15px;
							  vertical-align:-2px;
							  margin-right:5px;
							  word-spacing:-3px; 
					  }
					  .text-check     {
					  		  color:#3D79FE;
							  cursor:pointer;
					  }
					  .midder-border      {
					           width:100%;
							   .border-1    {
							   			display:inline-block;
										width:11%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:47px;
										
							   }
							    .border-2    {
							   			display:inline-block;
										width:30%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:110px;
										
							   }
					  }
			}
			.box-button        {
			          width:100%;
					  margin-top:20px;
					  button      {
							width:100%;
						    padding:10px;
							background:#3D79FE;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
					  }
			}
			.box-border        {
					 width:100%;
					 margin:30px auto;
					 ul           {
					      display:flex;
					      li         {
						          width:42%;
			                      border-bottom:1px solid #CBCBCB;
								  position:relative;
								  text-align:center;
								  &:nth-child(2)        {
								           width:16%;
										   border-bottom:none;
										  .text-OR     {
										           position:absolute;
												   top:-12px;
												   width:20%;
												   left:13px;
										  }
								  }
					            
						   }
					}
			}
			.box-button-img         {
			           width:100%;
					   margin-bottom:20px;
					   button      {
							width:100%;
						    padding:11px;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
							text-align:center;
							line-height:20px;
							img     {
							     margin-right:5px;
							}
					  }
					  &:last-child     {
					         margin-bottom:35px;
					         button      {
							       color:#3B1F1F; 
								   font-weight:bold;
							 }
					  }
			}
		}
	}
	.screenLayout {
		width:100%;
		height:calc(100vh);
		background:rgba(0,0,0,.7);
		position:fixed;
		top:0;
		left:0;
		z-index:100000;
		.content-box {
			padding:40px 30px 30px 30px;
			h3 {
				text-align:center;
				font-size:17pt;
			}
			.description {
				text-align:center;
				font-size:16px;
				color:#000;
				line-height:140%;
				padding:30px 0 20px 0;


			}
		}
	}
}

</style>